import { render, staticRenderFns } from "./MatchingStatus.vue?vue&type=template&id=5bc270ad&scoped=true"
import script from "./MatchingStatus.vue?vue&type=script&lang=js"
export * from "./MatchingStatus.vue?vue&type=script&lang=js"
import style0 from "./MatchingStatus.vue?vue&type=style&index=0&id=5bc270ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc270ad",
  null
  
)

export default component.exports